// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__26ns6","colCheckbox":"styles_colCheckbox__1lDOW"};